import { useEffect } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { CONTACT_EMAIL, CONTACT_PHONE_FORMATTED, CONTACT_PHONE_NUMBERS, PAGE_TITLE } from '../../../config/constants';
import categoryCSS from './Category.module.scss';
import ChatIcon from './icons/Chat';
import css from './ContactUs.module.scss';
import EmailIcon from '../../../components/icons/Email';
import Form from './Form';
import Overlay from '../../../components/Ovly';
import PhoneIcon from '../../../components/icons/Phone';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var chat = function chat() {
  window.Kustomer.open();
};

var ContactUs = function ContactUs(_ref) {
  var categories = _ref.categories;
  var CHAT = window.OV.CHAT;
  var businessClass = cc([css.item, 'chatter', {
    on: CHAT && CHAT.IN_BUSINESS
  }]); // Hook to change the page title

  useEffect(function () {
    document.title = "Contact Us".concat(PAGE_TITLE);
  }, []);

  var emailButton = /*#__PURE__*/_jsxs("div", {
    className: css.link,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.icon,
      children: /*#__PURE__*/_jsx(EmailIcon, {})
    }), /*#__PURE__*/_jsx("div", {
      className: css.label,
      children: "Email"
    }), /*#__PURE__*/_jsxs("div", {
      className: css.description,
      children: ["Still can\u2019t find what you\u2019re looking for? Shoot us a note.", ' ', CONTACT_EMAIL]
    })]
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h2", {
      className: categoryCSS.title,
      children: "Contact Us"
    }), /*#__PURE__*/_jsx("p", {
      className: css.copy,
      children: "Like the hiking buddy who brought the snacks, we\u2019re here to help."
    }), /*#__PURE__*/_jsxs("ul", {
      className: css.list,
      children: [/*#__PURE__*/_jsx("li", {
        className: css.item,
        children: /*#__PURE__*/_jsx(Overlay, {
          button: emailButton,
          label: "Send a message to Outdoor Voices Customer Service",
          medium: true,
          noPadding: true,
          children: /*#__PURE__*/_jsx("div", {
            className: css.overlay,
            children: /*#__PURE__*/_jsx(Form, {
              categories: categories,
              title: "Email Us",
              copy: "Still can\u2019t find what you\u2019re looking for? Shoot us a note."
            })
          })
        })
      }), /*#__PURE__*/_jsx("li", {
        className: businessClass,
        children: /*#__PURE__*/_jsxs("button", {
          "aria-label": "Open a chat dialog with our customer experience team",
          className: css.link,
          onClick: chat,
          type: "button",
          children: [/*#__PURE__*/_jsx("div", {
            className: css.icon,
            children: /*#__PURE__*/_jsx(ChatIcon, {})
          }), /*#__PURE__*/_jsx("div", {
            className: css.label,
            children: "Chat"
          }), /*#__PURE__*/_jsxs("div", {
            className: css.description,
            children: ["Open a live chat with an OV team member.", /*#__PURE__*/_jsx("br", {}), "Mon. - Fri. 9:00am - 5:30pm CST", /*#__PURE__*/_jsx("br", {}), "Sat. - Sun. 10:00am - 5:30pm CST"]
          })]
        })
      }), /*#__PURE__*/_jsx("li", {
        className: businessClass,
        children: /*#__PURE__*/_jsxs("a", {
          "aria-label": "Call or text Outdoor Voices customer service",
          href: "tel:+".concat(CONTACT_PHONE_NUMBERS),
          className: css.link,
          children: [/*#__PURE__*/_jsx("div", {
            className: css.icon,
            children: /*#__PURE__*/_jsx(PhoneIcon, {})
          }), /*#__PURE__*/_jsx("div", {
            className: css.label,
            children: "Call or Text"
          }), /*#__PURE__*/_jsxs("div", {
            className: css.description,
            children: [CONTACT_PHONE_FORMATTED, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
              className: css.hint,
              children: "Message and data rates may apply."
            })]
          })]
        })
      })]
    })]
  });
};

ContactUs.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string
  }))
};
export default ContactUs;